import { planTypes } from '@/common/constants';

export const ZOOM_DEVICE_CATEGORY = {
  [planTypes.ZOOM_DEVICE$DESK_PHONE]: 'edge',
  [planTypes.ZOOM_DEVICE$HEADSET]: 'headset',
}

export const snapImageParams = {
  attachType: "preview",
  subType: "300x300"
}
